export default __webpack_public_path__ + "69bc830ddf9b26cfe704e4ba34986c59.png";